import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI, firmsAPI } from '../api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [firms, setFirms] = useState([]);
  const [currentFirm, setCurrentFirm] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    authAPI.me()
      .then(r => {
        setUser(r.data.user);
        setFirms(r.data.firms);
        const saved = localStorage.getItem('currentFirmId');
        const firm = r.data.firms.find(f => f.id === parseInt(saved)) || r.data.firms[0];
        setCurrentFirm(firm || null);
      })
      .catch(() => localStorage.removeItem('token'))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const r = await authAPI.login({ username, password });
    localStorage.setItem('token', r.data.token);
    setUser(r.data.user);
    setFirms(r.data.firms);
    const firm = r.data.firms[0] || null;
    setCurrentFirm(firm);
    if (firm) localStorage.setItem('currentFirmId', firm.id);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('currentFirmId');
    setUser(null); setFirms([]); setCurrentFirm(null);
  };

  const switchFirm = (firm) => {
    setCurrentFirm(firm);
    localStorage.setItem('currentFirmId', firm.id);
  };

  const refreshFirms = async () => {
    const fr = await firmsAPI.getAll();
    setFirms(fr.data);
    if (currentFirm) {
      const updated = fr.data.find(f => f.id === currentFirm.id);
      if (updated) setCurrentFirm(updated);
    }
  };

  return (
    <AuthContext.Provider value={{ user, firms, currentFirm, loading, login, logout, switchFirm, refreshFirms }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
